import React, { useCallback, useEffect, useState } from "react";
import { message } from "antd";
import axios from "util/Api";
import API_ENDPOINTS from "util/apiEndpoints";

/**
 * Panel başlığının yanına konan sade Aktif/Pasif anahtarı.
 * Verilen botType için ai-bots kaydını bulur, botSettings.update ile açıp kapatır.
 * Bot yoksa hiçbir şey render etmez (panel bozulmaz).
 */
const BotStatusToggle = ({ botType, style }) => {
  const [bot, setBot] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const load = useCallback(async () => {
    if (!botType) {
      setLoading(false);
      return;
    }
    try {
      const res = await axios.post(API_ENDPOINTS.aiBots.list, {});
      const rows = Array.isArray(res && res.data && res.data.data) ? res.data.data : [];
      const found = rows.find((b) => (b.type || b.bot_type) === botType) || null;
      setBot(found);
    } catch (e) {
      setBot(null);
    } finally {
      setLoading(false);
    }
  }, [botType]);

  useEffect(() => {
    load();
  }, [load]);

  const enabled = bot ? bot.enabled !== false : false;

  const toggle = async () => {
    if (!bot || !bot.id || saving) return;
    const next = !enabled;
    setSaving(true);
    try {
      await axios.post(API_ENDPOINTS.botSettings.update, { id: bot.id, enabled: next });
      setBot((prev) => (prev ? { ...prev, enabled: next } : prev));
      message.success(next ? "Çalışan aktif edildi" : "Çalışan pasife alındı");
    } catch (e) {
      message.error("Güncelleme hatası");
    } finally {
      setSaving(false);
    }
  };

  if (loading || !bot) return null;

  return (
    <button
      type="button"
      onClick={toggle}
      disabled={saving}
      title={enabled ? "Aktif — kapatmak için tıkla" : "Pasif — açmak için tıkla"}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
        cursor: saving ? "default" : "pointer",
        padding: "6px 12px",
        borderRadius: 999,
        background: enabled ? "rgba(34,197,94,.12)" : "rgba(148,163,184,.14)",
        border: "1px solid " + (enabled ? "rgba(34,197,94,.35)" : "rgba(148,163,184,.3)"),
        opacity: saving ? 0.6 : 1,
        ...style,
      }}
    >
      <span
        style={{
          width: 34,
          height: 20,
          borderRadius: 11,
          background: enabled ? "#22c55e" : "rgba(148,163,184,.45)",
          position: "relative",
          transition: "background .2s",
          flexShrink: 0,
        }}
      >
        <span
          style={{
            position: "absolute",
            top: 2,
            left: enabled ? 16 : 2,
            width: 16,
            height: 16,
            borderRadius: "50%",
            background: "#fff",
            transition: "left .2s",
            boxShadow: "0 1px 2px rgba(0,0,0,.3)",
          }}
        />
      </span>
      <span style={{ fontSize: 13, fontWeight: 700, color: enabled ? "#16a34a" : "var(--cp-faint)" }}>
        {enabled ? "Aktif" : "Pasif"}
      </span>
    </button>
  );
};

export default BotStatusToggle;
